"use client";

import dynamic from "next/dynamic";

const Dubbing = dynamic(() => import("./Dubbing"));

export default Dubbing;
